import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { useStudent } from "@/context/StudentContext";
import { StudentAuthShell } from "./StudentLogin";
import { inputCls, btnPrimary } from "@/components/portal/PortalUI";

export default function StudentSetPassword({ mode }) {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);
  const { setStudent } = useStudent();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/student/auth/token-info", { params: { token } }).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e, "This link is invalid.")));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setError("Password must be at least 8 characters.");
    if (pw !== pw2) return setError("Passwords do not match.");
    setBusy(true); setError("");
    try {
      if (mode === "activate") {
        const r = await api.post("/student/auth/activate", { token, password: pw });
        setStudent(r.data); navigate("/student?welcome=1");
      } else {
        const r = await api.post("/student/auth/reset-password", { token, password: pw });
        setDone(r.data.message);
      }
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  const title = mode === "activate" ? "Activate Your Student Portal" : "Choose a New Password";
  return (
    <StudentAuthShell title={title} subtitle={info ? `${info.name} · ${info.email}` : ""}>
      {done ? (
        <div className="space-y-4"><p className="text-emerald-700 text-sm" data-testid="reset-done">{done}</p>
          <Link to="/student/login" className={`${btnPrimary} w-full`}>Go to Student Login</Link></div>
      ) : !info && error ? (
        <div className="space-y-4"><p className="text-red-700 text-sm" data-testid="token-error">{error}</p>
          <Link to="/student/login" className={`${btnPrimary} w-full`} data-testid="token-error-login">Request a new link</Link></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="set-password-form">
          {mode === "activate" && info && <p className="text-sm text-dark-text/70">Welcome! You've been enrolled in <strong className="text-navy">{info.programs.join(" & ")}</strong>. Create a password to activate your account and begin onboarding.</p>}
          <input type="password" placeholder="New password (min 8 characters)" value={pw} onChange={(e) => setPw(e.target.value)} className={inputCls} data-testid="new-password" />
          <input type="password" placeholder="Confirm password" value={pw2} onChange={(e) => setPw2(e.target.value)} className={inputCls} data-testid="confirm-password" />
          {error && <p className="text-red-700 text-sm" data-testid="set-password-error">{error}</p>}
          <button disabled={busy || !info} className={`${btnPrimary} w-full`} data-testid="set-password-submit">{busy ? "Saving…" : mode === "activate" ? "Activate Account" : "Reset Password"}</button>
        </form>
      )}
    </StudentAuthShell>
  );
}
